import { render } from "./EventDocumentsCard.vue?vue&type=template&id=65fc69d8"
import script from "./EventDocumentsCard.vue?vue&type=script&lang=ts"
export * from "./EventDocumentsCard.vue?vue&type=script&lang=ts"

import "./EventDocumentsCard.vue?vue&type=style&index=0&id=65fc69d8&lang=scss"
script.render = render

export default script